import { ReactElement } from 'react';
import {
  SContainer,
  SContainer2,
  SLabel,
  SDescription,
  SSecondaryLabel,
  SLeft,
  SRight,
  STop,
  SBottom,
} from './EnhancedOption.style';
import './enhanced-option.css';

type LayoutType = 0 | 1;

export const EnhancedOption = ({
  label,
  description,
  secondaryLabel,
  layout = 0,
}: {
  label: string;
  description: string;
  secondaryLabel?: string | null;
  layout?: LayoutType;
}): ReactElement => {
  if (layout === 0) {
    return (
      <SContainer className="enhanced-option-item">
        <SLeft hasRight={!!secondaryLabel}>
          <SLabel strong>{label}</SLabel>
          <SDescription strong type="secondary" className="enhanced-option-item-description">
            {description}
          </SDescription>
        </SLeft>
        {!!secondaryLabel && (
          <SRight>
            <SSecondaryLabel>{secondaryLabel}</SSecondaryLabel>
          </SRight>
        )}
      </SContainer>
    );
  }
  return (
    <SContainer2 className="enhanced-option-item">
      <STop>
        <SLabel strong>{label}</SLabel>
        <SSecondaryLabel>{secondaryLabel}</SSecondaryLabel>
      </STop>
      <SBottom className="enhanced-option-item-description">
        <SDescription strong type="secondary">
          {description}
        </SDescription>
      </SBottom>
    </SContainer2>
  );
};
